import Vue from "vue";
import Vuex from "vuex";
import service from "../../services/gestionTiempos/estadistics";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    itemsLastWeek: [],
    visualLastWeek: [],
    optionsLasWeek: {
      labels: [],
    },
    seriesLasWeek: [],
    itemsLiquidated: [],
    visualLiquidated: [],
    optionsDays: {
      labels: [],
    },
    optionsHours: {
      labels: [],
    },
    serieLiqDays: [],
    serieAutDays: [],
    serieLiqHours: [],
    serieAutHours: [],
  },
  mutations: {
    setItemsLastWeek(
      state,
      { items = [], visual = [], options = { labels: [] }, series = [] }
    ) {
      state.itemsLastWeek = items;
      state.visualLastWeek = visual;
      state.optionsLasWeek = options;
      state.seriesLasWeek = series;
    },
    setLiquidated(
      state,
      {
        items = [],
        visualI = [],
        optionsDays = { labels: [] },
        optionsHours = { labels: [] },
        serieAutDays = [],
        serieAutHours = [],
        serieLiqDays = [],
        serieLiqHours = [],
      }
    ) {
      state.itemsLiquidated = items;
      state.visualLiquidated = visualI;
      state.optionsDays = optionsDays;
      state.optionsHours = optionsHours;
      state.serieAutDays = serieAutDays;
      state.serieAutHours = serieAutHours;
      state.serieLiqDays = serieLiqDays;
      state.serieLiqHours = serieLiqHours;
    },
  },
  actions: {
    async getItemsLastWeek(state, date) {
      return new Promise(async (resolve, reject) => {
        try {
          let items = await state.state.service.getEstadistic1(date);

          let visual = [];
          let options = {
            labels: [],
            noData: {
              text: "Por el momento no hay datos para mostrar",
              align: "center",
              style: {
                fontSize: "15px",
                fontFamily: "ubuntu",
              },
            },
          };
          let series = [];
          items.map((item) => {
            visual.push({
              Presentes: item.presents,
              Ausentes: item.ausents,
              Inconsistencias: item.inconsistencies,
              Caidas: item.falls,
              Tardes: item.lates,
              RetiroAnterior: item.retreatBefore,
              LicDias: item.daysLicense,
              LicHoras: item.hoursLicense,
              Extras: item.additionals,
            });
          });

          if (visual[0]) {
            Object.entries(visual[0]).forEach(([key, value]) => {
              if (value > 0 && value != null) {
                series.push(value);
                options.labels.push(key);
              }
            });
          }
          state.commit("setItemsLastWeek", {
            items,
            visual,
            options,
            series,
          });
          resolve(true);
        } catch (error) {
          state.commit("setItemsLastWeek", {});
          reject(error);
        }
      });
    },
    async getItemsLiquidated(state, date) {
      return new Promise(async (resolve, reject) => {
        try {
          let items = await state.state.service.getEstadistic2(date);

          let visualI = [];
          let optionsDays = {
            labels: [],
            noData: {
              text: "Por el momento no hay datos para mostrar",
              align: "center",
              style: {
                fontSize: "15px",
                fontFamily: "ubuntu",
              },
            },
          };
          let optionsHours = {
            labels: [],
            noData: {
              text: "Por el momento no hay datos para mostrar",
              align: "center",

              style: {
                fontSize: "15px",
                fontFamily: "ubuntu",
              },
            },
          };
          let serieAutDays = [];
          let serieAutHours = [];
          let serieLiqDays = [];
          let serieLiqHours = [];

          items.map((item) => {
            visualI.push({
              CantCC: item.CCQuantity,
              CantAutorizada: item.authorizedQuantity,
              CantLiquidada: item.liquidatedQuantity,
              Nombre: item.name,
              Unidad: item.unit,
            });
          });

          visualI.map(function (element) {
            if (element.Unidad == "di") {
              optionsDays.labels.push(
                element.Nombre.slice(0, 15).concat("...").trim()
              );
              serieAutDays.push(element.CantAutorizada);
              serieLiqDays.push(element.CantLiquidada);
            } else {
              optionsHours.labels.push(
                element.Nombre.slice(0, 15).concat("...").trim()
              );
              serieAutHours.push(element.CantAutorizada);
              serieLiqHours.push(element.CantLiquidada);
            }
          });
          state.commit("setLiquidated", {
            items,
            visualI,
            optionsDays,
            optionsHours,
            serieAutDays,
            serieAutHours,
            serieLiqDays,
            serieLiqHours,
          });
          resolve(true);
        } catch (error) {
          state.commit("setLiquidated", {});
          reject(error);
        }
      });
    },
  },
  getters: {
    getWorkingHours(state) {
      var lab;
      var hora;
      var min;

      Object.entries(state?.itemsLastWeek[0]).forEach(([key, value]) => {
        if (key === "employeeWorkedHours") {
          lab = value;
        }
        hora = Math.floor(lab / 60);

        min = Math.floor(hora * 60);
        min = lab - min;
        min = min < 10 ? "0" + min : min;
      });

      return hora + ":" + min;
    },
    getHoursWorked(state) {
      var lab;
      var hora;
      var min;

      Object.entries(state?.itemsLastWeek[0]).forEach(([key, value]) => {
        if (key === "addHoursWorked") {
          lab = value;
        }
        hora = Math.floor(lab / 60);
        min = Math.floor(hora * 60);
        min = lab - min;
        min = min < 10 ? "0" + min : min;
      });

      return hora + ":" + min;
    },
  },
});
